<script>
import { Pie, mixins } from 'vue-chartjs'

export default {
    extends: Pie,
    props: ['data', 'options'],
    mixins: [mixins.reactiveProp],
    mounted() {
        this.renderChart(this.data, this.options);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/GraficoDePizza.vue